import {useSelector} from "react-redux";

import {compact, uniq} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {GTMEvent, PreferencesAction, propertyConfiguratorAnalytics} from "../analytics/events";
import {Floor, FloorNumeric} from "../types/Floor";
import {PropertyConfiguratorSearchFormValuesType} from "../types/PropertyConfiguratorSearchFormValuesType";

export const usePropertyConfiguratorFiltersAnalytics = (gtmEvent: GTMEvent) => {
    const formValues = useSelector((state: IRPStore) => state.propertyConfigurator.formValues);
    const propertyQuarters = useSelector((state: IRPStore) => state.variables.data?.property_quarters);

    const trackArea = (values?: Partial<PropertyConfiguratorSearchFormValuesType>) => {
        const {lower: areaLower, upper: areaUpper} = (values || formValues).area;

        if (areaLower || areaUpper) {
            propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
                preferences_action: PreferencesAction.FLAT_SIZE,
                preferences: uniq(compact([areaLower, areaUpper])).join(" - ")
            });
        }
    };

    const trackFloors = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.FLOOR,
            preferences: formValues.floors.map((floor: Floor) => FloorNumeric[floor]).join(" - ")
        });
    };

    const trackLocalisation = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(GTMEvent.FLAT_CONFIG_MODAL, {
            preferences_action: PreferencesAction.LOCALISATION,
            preferences: formValues?.search?.regions?.map(({short_name}: {short_name: string}) => short_name).join(", ") ?? ""
        });
    };

    const trackRooms = (values?: Partial<PropertyConfiguratorSearchFormValuesType>) => {
        if (values?.rooms?.lower) {
            propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
                preferences_action: PreferencesAction.ROOMS_NUMBER,
                preferences: values.rooms.lower
            });
        }
    };

    const trackWorldDirections = () => {
        if (formValues.world_directions?.length && propertyQuarters) {
            propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
                preferences_action: PreferencesAction.LIGHT,
                preferences: uniq(
                    formValues.world_directions.map((direction: number) => {
                        return propertyQuarters.find((quarter) => quarter.value === direction)?.label;
                    })
                ).join(" - ")
            });
        }
    };

    const trackLoan = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.LOAN,
            preferences: !!formValues.loan
        });
    };

    const trackAftermarket = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.AFTERMARKET,
            preferences: !!formValues.aftermarket
        });
    };

    const trackPrice = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.PRICE,
            preferences: formValues.price.upper
        });
    };

    const trackAdditionalAreas = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.ADDITIONAL_SPACES,
            preferences: formValues.rooms_area_type_selected.filter((area: string) => area.includes("as")).map((area: string) => area.split("as_")[1])
        });
    };

    const trackKitchenType = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.KITCHEN_TYPE,
            preferences: formValues.kitchen_type
        });
    };

    return {
        trackArea,
        trackFloors,
        trackLocalisation,
        trackRooms,
        trackWorldDirections,
        trackLoan,
        trackAftermarket,
        trackPrice,
        trackKitchenType,
        trackAdditionalAreas
    };
};
import {useSelector} from "react-redux";

import {compact, uniq} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {GTMEvent, PreferencesAction, propertyConfiguratorAnalytics} from "../analytics/events";
import {Floor, FloorNumeric} from "../types/Floor";
import {PropertyConfiguratorSearchFormValuesType} from "../types/PropertyConfiguratorSearchFormValuesType";

export const usePropertyConfiguratorFiltersAnalytics = (gtmEvent: GTMEvent) => {
    const formValues = useSelector((state: IRPStore) => state.propertyConfigurator.formValues);
    const propertyQuarters = useSelector((state: IRPStore) => state.variables.data?.property_quarters);

    const trackArea = (values?: Partial<PropertyConfiguratorSearchFormValuesType>) => {
        const {lower: areaLower, upper: areaUpper} = (values || formValues).area;

        if (areaLower || areaUpper) {
            propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
                preferences_action: PreferencesAction.FLAT_SIZE,
                preferences: uniq(compact([areaLower, areaUpper])).join(" - ")
            });
        }
    };

    const trackFloors = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.FLOOR,
            preferences: formValues.floors.map((floor: Floor) => FloorNumeric[floor]).join(" - ")
        });
    };

    const trackLocalisation = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(GTMEvent.FLAT_CONFIG_MODAL, {
            preferences_action: PreferencesAction.LOCALISATION,
            preferences: formValues?.search?.regions?.map(({short_name}: {short_name: string}) => short_name).join(", ") ?? ""
        });
    };

    const trackRooms = (values?: Partial<PropertyConfiguratorSearchFormValuesType>) => {
        if (values?.rooms?.lower) {
            propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
                preferences_action: PreferencesAction.ROOMS_NUMBER,
                preferences: values.rooms.lower
            });
        }
    };

    const trackWorldDirections = () => {
        if (formValues.world_directions?.length && propertyQuarters) {
            propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
                preferences_action: PreferencesAction.LIGHT,
                preferences: uniq(
                    formValues.world_directions.map((direction: number) => {
                        return propertyQuarters.find((quarter) => quarter.value === direction)?.label;
                    })
                ).join(" - ")
            });
        }
    };

    const trackLoan = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.LOAN,
            preferences: !!formValues.loan
        });
    };

    const trackAftermarket = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.AFTERMARKET,
            preferences: !!formValues.aftermarket
        });
    };

    const trackPrice = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.PRICE,
            preferences: formValues.price.upper
        });
    };

    const trackAdditionalAreas = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.ADDITIONAL_SPACES,
            preferences: formValues.rooms_area_type_selected.filter((area: string) => area.includes("as")).map((area: string) => area.split("as_")[1])
        });
    };

    const trackKitchenType = () => {
        propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(gtmEvent, {
            preferences_action: PreferencesAction.KITCHEN_TYPE,
            preferences: formValues.kitchen_type
        });
    };

    return {
        trackArea,
        trackFloors,
        trackLocalisation,
        trackRooms,
        trackWorldDirections,
        trackLoan,
        trackAftermarket,
        trackPrice,
        trackKitchenType,
        trackAdditionalAreas
    };
};
